import { useContext } from "react";

import { ScheduleContext } from "Context/Schedule";

export const useScheduleContext = () => {
  const scheduleContext = useContext(ScheduleContext);

  if (scheduleContext === null) {
    throw new Error("Context not provided");
  }

  return {
    ...scheduleContext,
  };
};
